<template>
  <div class="tkChangeDetail full-height linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
    >
      {{ alterDataDetail.changeNo }}
    </ld-header>
    <!--  -->
    <div class="TkChangeDetailswrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="pad-8">
          <div class="white m-b-5 pad-8">
            <div class="font22 font-md fontTitle">
              <span>{{ alterDataDetail.orderStatus }}</span>
              <ld-email-popup
                v-if="changeOrderId"
                :id="changeOrderId"
                :djlx="11011"
                :order-no="alterDataDetail.orderNo"
              />
            </div>
            <van-row>
              <van-col span="24">
                {{ $t('C205','企业改签原因') }}：{{ alterDataDetail.changeReasonVip }}
              </van-col>
            </van-row>
            {{ $t('K121','申请时间') }}：{{ alterDataDetail.applyDate }}
            <van-row v-show="alterDataDetail.changeReason">
              <van-col span="24">
                非自愿原因：{{ alterDataDetail.changeReason }}
              </van-col>
              <!-- <van-col span="4">
          退票证明  查看附件 非自愿退票
          </van-col> -->
            </van-row>
            <van-row v-show="payWay">
              <van-col span="24">
                {{ payWay }}{{ $t('B014','支付') }}
              </van-col>
              <!-- <van-col span="4">
          退票证明  查看附件 非自愿退票
          </van-col> -->
            </van-row>
          </div>

          <van-cell class="m-b-5 round-sm">
            <van-row>
              <van-col span="18">
                {{ $t('F012','原订单号') }}：{{ alterDataDetail.orderNo }}
              </van-col>
              <van-col
                span="6"
                @click="lookToOldDetail"
                class="text-right main-color"
              >
                {{ $t('C338','查看原订单') }}
              </van-col>
            </van-row>
          </van-cell>
          <!-- 原航段 -->
          <div
            v-for="(flightItem,index) in rangeList"
            :key="index"
          >
            <voyage
              class="m-b-5"
              :flight="flightItem"
              :show-rule="flightItem.newChange?true:false"
              :showCar="flightItem.newChange"
              :ccsqdId="alterDataDetail.ccsqdId"
            >
              <template #tag>
                <van-tag 
                  v-if="flightItem.newChange"
                  class="bg-main white"
                  size="medium"
                >
                  <span>新行程</span>
                </van-tag>
                
                <van-tag
                  v-else
                  size="medium"
                  color="#8b8ba6"
                >
                  <span>原行程</span>
                </van-tag>
              </template>
            </voyage>
          </div>
        
          <!-- 乘机人 -->
          <van-cell class="m-b-5">
            <template slot="title">
              {{ alterDataDetail.psg }}
              <van-tag
                type="warning"
                v-show="alterDataDetail.fsEmpId"
              >
                {{ $t('attach','附') }}
              </van-tag>
            </template>
            <template slot="label">
              <div>{{ alterDataDetail.idType|cardType }}：{{ alterDataDetail.idNo }}</div>
              <div>{{ $t('C232','原票号') }}：{{ alterDataDetail.oTkno }}</div>
              <div>{{ $t('C234','改签后票号') }}：{{ alterDataDetail.nTkno }}</div>
            </template>
          </van-cell>

          <!--  -->
          <!-- <van-cell title="改签进度" />
          <van-steps
            class="ld-step m-b-5 font14"
            direction="vertical"
            :active="changeStatus"
          >
            <van-step> 申请已提交 </van-step>
            <van-step> 办理改签中 </van-step>
            <van-step v-if="alterDataDetail.payStatus==1">
              已使用<span>{{ alterDataDetail.paySubjectName }}</span>支付
            </van-step>
            <van-step> 改签办理完成</van-step>
          </van-steps> -->

          <!-- 审批规则 -->
          <approval
            v-show="alterDataDetail.vipStatus ==1 || alterDataDetail.vipStatus==2 || alterDataDetail.vipStatus==3"
            :vip-status="alterDataDetail.vipStatus"
            :order-id="changeOrderId"
            :spgz-id="alterDataDetail.appId"
            v-if="alterDataDetail.vipStatus"
            :isssbz="alterDataDetail.isShowApproval!='1'"
          />
          <ld-uploader
            class="mt5 round-sm overflow"
            v-if="changeOrderId"
            :order-id="changeOrderId"
            :glywlx="'11011'"
            :cjlx="2"
            :order-status='alterDataDetail.oldSeatType'
          />

          <!-- 审批状态     当审批  appid 为空时，不显示查看审批装进度-->
          <!--  -->
        </div>
      </mescroll-vue>
    </div>
    <!---->
    <ld-tabbar class="bg-white shadow">
      <van-row
        class="full-width pad-lr-8"
        type="flex"
        align="center"
        gutter="8"
        justify="space-between"
      >
        <van-col span="10">
          <span class="font12 red">&yen; </span>
          <span class="font16 red"> {{ alterDataDetail.changeAmount }}</span>
        </van-col>
        <van-col span="1" />
        <van-col
          span="8"
          v-if="alterDataDetail.showCancelButton==1"
        >
          <ld-button
            defaults
            size="md"
            @click="cancleAlter(alterDataDetail.changeId)"
          >
            {{ $t('B008','取消') }}
          </ld-button>
        </van-col>
        <van-col
          span="8"
          v-if="alterDataDetail.isShowCancelApproval==1"
        >
          <ld-button
            defaults
            size="md"
            @click.native="revertApproval"
          >
            {{ $t('B065','撤回') }}
          </ld-button>
        </van-col>
        <van-col
          span="8"
          v-if="alterDataDetail.showSendCkButton == 1||alterDataDetail.showSendCkButton == 2"
        >
          <ld-button
            main
            size="md"
            @click="toSend()" 
          >
            <span v-show="alterDataDetail.showSendCkButton == 1">{{ $t('B028','送审') }}</span>
            <span v-show="alterDataDetail.showSendCkButton == 2">{{ $t('Submit','再送审') }}</span>
          </ld-button>
        </van-col>
        <van-col
          span="6"
          v-if="alterDataDetail.showPayButton == 1"
        >
          <ld-button
            main
            size="md"
            @click="toPay(alterDataDetail.changeId )"
          >
            {{ $t('B014','支付') }}
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
    <!--支付  -->
    <!-- <ld-pay
      ref="pay"
      @selected="pay"
      order-type="11003"
      :order-id="changeOrderId"
    /> -->
  
  </div>
</template>
<script>
import ldButton from 'Common/ldButton'
import { Cell , Field ,Checkbox ,Tag, Step, Steps, Popup} from 'vant'
import voyage from 'Components/tk/voyage/voyage.vue'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import approval from 'Components/approval/approval'
// import ldPay from 'Components/ldPay/index.vue'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { changeData } from './utils'
import Bussiness from 'Utils/business'
import ldEmailPopup from 'Components/LdEmailPopup'
import ldUploader from 'Components/ldUploader'

export default {
  name:'TkChangeDetail',
  provide: {
    orderType: $dict.ORDER_TYPE.tk.change
  },
  components: {
    ldButton,
    [Cell.name]:Cell,
    [Field.name]:Field,
    [Checkbox.name]:Checkbox,
    [Tag.name]:Tag,
    [Step.name]:Step,
    [Steps.name]:Steps,
    [Popup.name]:Popup,
    voyage,
    ldTabbar,
    approval,
    // ldPay,
    MescrollVue,
    ldEmailPopup,
    ldUploader
  },
  data: function() {
    return {
      down:{use:false},
      alterDataDetail: '',
      payWay: '',
      isShowApproval: 0,
      spjd:'',   //审批进度
      vipStatus:'', // 审批状态
      alterProgressList:['申请已提交','办理改签中','付款','改签办理完成'],
      showRefundChange:false,
      rangeList:[],
      emailPopup:false
    }
  },
  activated(){
    this.getAlterTicketDetail()
  },
  created() {
    this.getAlterTicketDetail()
  },
  filters: {
    filterArriveTime: function(val) {
      return val.substr(11, 5)
    },
    DateYueOrRi: function(val) {
      var gao, hao
      gao = val.substr(5, val.length - 5).split('-')
      hao = gao[0] + '月' + gao[1] + '日'
      return hao
    },
    filterWeek: function(val) {
      var date = new Date(val)
      var week
      if(date.getDay() == 0) week = '周日'
      if(date.getDay() == 1) week = '周一'
      if(date.getDay() == 2) week = '周二'
      if(date.getDay() == 3) week = '周三'
      if(date.getDay() == 4) week = '周四'
      if(date.getDay() == 5) week = '周五'
      if(date.getDay() == 6) week = '周六'
      return week
    },
  },
  computed: {
    changeOrderId(){
      return this.$route.query.orderId||this.$route.query.id||''
    },
    changeStatus(){
      if(this.alterDataDetail.changeStatus==5){
        return false
      }
      return parseInt(this.alterDataDetail.changeStatus)
    }
  },
  methods: {
    rightShare () {
      this.emailPopup = true
    },
    // 查看改签rule
    lookAlterDetail(info){
      var obj={
        'airline': this.alterDataDetail.airline,
        'cabin': info.nCabin,
        'departDate': info.nDepartDate,
        'salePrice': ''
      }
      this.$refs.mychild.getParams(obj)
      this.showRefundChange = true
    },
    // 获取改签详情
    getAlterTicketDetail() {
      this.$api['tkOrder/tkChangeOrderDetail']({
        changeOrderId: this.changeOrderId
      }).then((res) => {
        let cache=res.data||{}
        this.alterDataDetail = cache
        if(cache.rangeList&&cache.rangeList.length>0){
          this.rangeList=changeData(cache.rangeList)
        }
        this.vipStatus = cache.vipStatus
        this.getAlterProgress(this.alterDataDetail.changeId)
        this.panDuanZhuangTai(this.alterDataDetail.changeStatus)
      })
    },
    // 获取 改签进度
    getAlterProgress(id){
      this.$api['approval/vipOrderAppProgress']({
        'orderId': id,
        'orderType': 11003
      }).then((resp) => {
        if(resp.data){
          this.spjd = resp.data.spjd
          this.vipStatus = resp.data.vipStatus
        }
      })
    },
    // 判断状态   进度条显示
    panDuanZhuangTai(Tai) {
      var Num = Tai - 0
      if(Tai > 0) {
        for(var i = 0; i < Num; i++) {
          if(i < Num) {
            var a = i + 1
            this.$set(this, 'isShowTai' + a, true)
          }
        }
      }
    },
    //操作按钮
    toPay() {
      // this.toggle('pay')
      // IBE 支付校验 2000039
      /*if ('2000039' === this.alterDataDetail.supplierCode) {
				// 调用改期费查询接口
				this.$api['tkOrder/tkChangeQueryFee']({
					'newPnr': this.alterDataDetail.nPnrNo,//新PNR
					'tknos': this.alterDataDetail.oTkno,//原票号
					'plane': this.alterDataDetail.nModel,// 机型
					'changeOrderId': this.alterDataDetail.changeId,// 改期订单ID
					'update': '1',// 是否更新到改期单
				}).then((res) => {
					const cache=res.data||{}
					if (this.alterDataDetail.nFcny !== cache.ticketFare || cache.exchangeFee !== this.alterDataDetail.purchanseChangeAmount) {
						this.$dialog.alert('改期费用已发生变化')
						this.getAlterTicketDetail()
					} else {
						this.$router.push({path:'/pay/payment',query:{orderType:'11003',orderId:this.changeOrderId}})
					}
				}).catch(err => {
					console.log(err)
					this.$dialog.alert('核对改期费失败')
				})
				return
			}*/
      this.$router.push({path:'/pay/payment',query:{orderType:'11003',orderId:this.changeOrderId}})
    },
    pay(){
      this.getAlterTicketDetail()
    },
    toSend() {
      this.alterDataDetail.orderType = '11003'
      Bussiness.ApprovalSend(this.alterDataDetail)
    },
    async revertApproval () {
      this.alterDataDetail.orderType = '11003'
      await Bussiness.ApprovalRevert(this.alterDataDetail)
      this.getAlterTicketDetail()
    },
    //取消改签单
    cancleAlter(id) {
      this.$dialog.confirm({message:'您确定要取消改签吗？'}).then(() =>{
        this.toCancleAlterAjax(id)
      })
    },
    toCancleAlterAjax(id) {
      this.$api['tkOrder/cancelChangeOrder']({
        'changeId': id
      }).then(() => {
        this.$toast('取消改签成功！')
        this.getAlterTicketDetail() //刷新页面
      })
    },
    // 查看附件  
    lookFuJian(){
      this.$dialog.alert('暂时不支持查看附件！亲')
    },
    // 查看原订单
    lookToOldDetail(){
      this.$router.push({path:'/tk/tkOrderDetail',query:{'orderId':this.alterDataDetail.orderId}})
    },
  }
}
</script>
<style lang="less" scoped>
.tkChangeDetail{
  .fontTitle{
    display: flex;
    justify-content:space-between;
    align-items:center;
    .dowPdf{
      font-size: 16px;
    }
  }
}
.m-b-5{
    margin-bottom: 5px;
} 
.pad-lr-8{
    padding-left: 8px;
    padding-right: 8px;
}
.pad-8{
    padding: 8px;
}
.TkChangeDetailswrapper{
     height: calc(100vh - 94px);
    overflow: hidden;
}

</style>